import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import { esmobiotv } from "../../constants/esmobiotv";
import { movies } from '../../constants/movies';
import * as vars  from '../../constants/constants';
import { config } from "../../constants/domainConfig";
import { showSearchBar } from '../../actions/HeaderActions';
import { searchText } from '../../actions/SearchActions';
import { getVideoOrChannelRelatedData } from '../../actions/PlayActions';
import { console_log,bidiotvMoviesListByLang } from '../../utils/helper';
import  { spanish } from "../../constants/spanish";
import { English } from "../../constants/english";
import Swiper from 'react-id-swiper';
import { FormattedMessage } from 'react-intl';

let language;

class SearchPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: ''
        };

        this.goToPlay = this.goToPlay.bind(this);
        this.goToPlayOthers = this.goToPlayOthers.bind(this);
    }

    componentWillMount() {
        console_log(this.props.path.split("/"));
        let pathName = this.props.path.split("/");
        this.setState({
            type: "videos"
        });
    }

    componentWillUnmount() {
        this.props.searchText('');
    }

    goToPlay(data, event) {
        event.preventDefault();
        this.props.showSearchBar(!this.props.header.showSearchBar);
        this.props.getVideoOrChannelRelatedData(data);
        this.props.searchText('');
        if (data.channel) {
            this.props.goToPage(`/play/channel?uid=${this.props.access.uid}`);
        } else {
            this.props.goToPage(`/play/video?vid=${data.id}&uid=${this.props.access.uid}`);
        }
    }

    goToPlayOthers(data, event) {
        event.preventDefault();
        this.props.showSearchBar(!this.props.header.showSearchBar);
        this.props.getVideoOrChannelRelatedData(data);
        this.props.searchText('');
        this.props.goToPage('/show');
    }

    searchvideos(){
        let mixContent = bidiotvMoviesListByLang.concat(this.props.category.videos)
        const gridIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 290 290" width="12" height="12"><g fill="#d51a92"><path d="M0 220h70v70H0zM0 110h70v70H0zM0 0h70v70H0zM110 220h70v70h-70zM110 110h70v70h-70zM110 0h70v70h-70zM220 220h70v70h-70zM220 110h70v70h-70zM220 0h70v70h-70z"/></g></svg>'
        var regEx = new RegExp(this.props.search.searchText, 'i');
        if(config.language== 'spanish'){
            language = spanish;
        }
        else{
            language = English;
        }
        let channelSearch, videoSearch , recentSearch,bidiotvsearch;

        if(config.title == 'bidiotv'){
            bidiotvsearch = [].concat.apply([], bidiotvMoviesListByLang.map((c) => c.videos)
            ).filter((v) => {
                if (regEx.test(v.name)) {
                    return v;
                }
            });
        }
        else {
                channelSearch = this.props.category.channels.filter((channel) => {
                    if (regEx.test(channel.channelName)) {
                        return channel
                    }
                });

            if(config.title == 'watch'){
                videoSearch = [].concat.apply([], mixContent.map((c) => c.videos)).filter((v) => {
                    if (regEx.test(v.name)) {
                        return v;
                    }
                });
            }
            else {
                videoSearch = [].concat.apply([], this.props.category.videos.map((c) => c.videos)).filter((v) => {
                    if (regEx.test(v.name)) {
                        return v;
                    }
                });
            }

            if(config.title == 'es' && window.innerWidth <= 575){
                videoSearch = [].concat.apply([], esmobiotv.map((c) => c.videos)).filter((v) => {
                    if (regEx.test(v.name)) {
                        return v;
                    }
                });
            }

            if(config.title == 'es' && window.innerWidth >= 576){
                videoSearch = [].concat.apply([], esmobiotv.map((c) => c.videos)).filter((v) => {
                    if (regEx.test(v.name)) {
                        return v;
                    }
                });
            }

            recentSearch = [].concat.apply([], movies.map((c) => c.videos)).filter((v) => {
                if (regEx.test(v.name)) {
                    return v;
                }
            });
        }
        const playIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path fill="#fff" d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>';


        if(config.title == 'bidiotv' && window.innerWidth <= 575){
            const slides = {
                spaceBetween: 30,
                direction: 'horizontal',
                slidesPerView: 'auto',
                speed: 500,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    575: {
                        spaceBetween: 15,
                    },
                }
            };
            return(
                bidiotvMoviesListByLang.map((category) => {
                    let newVideos = category.videos.filter((video) => {
                        if (regEx.test(video.name)) {
                            return video;
                        }
                    });
                    if (newVideos.length > 0) {
                        return (
                            <div className="search-page--es">
                                <div key={category.id} className="portrait-wrapper">
                                    <div className="d-flex justify-content-between channel-head">
                                        <h3 className="channel-title">{category.name[config.subDomain]}</h3>
                                    </div>
                                    {newVideos.length > 0 ?
                                        <div className="category-slider">
                                            <Swiper {...slides} rebuildOnUpdate={false} shouldSwiperUpdate={true}>
                                                {newVideos.reverse().map((video) => {
                                                    return (
                                                        <div key={video.id} className="channels-thumb"
                                                            onClick={this.goToPlay.bind(this, { video: video, id: video.id} )}>
                                                            <div className="channels-image">
                                                                <img className="channels-thumb__image"
                                                                        src={video.preview} alt={video.name}/>
                                                                <div className="channels-thumb__details">
                                                                    <div className="channels-thumb__inner">
                                                                        <div className="channels-thumb__name">
                                                                            {video.name}
                                                                        </div>
                                                                        {/* <div className="channels-thumb__extra">
                                                                            <span className="channels-thumb__time">1h 40m</span>
                                                                        </div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                            </Swiper>
                                        </div>
                                        : ''
                                    }
                                </div>
                            </div>
                        )
                    }
                })
            )

        }
        if(config.title == 'bidiotv' && window.innerWidth >= 576){
            return(
                <div className="search-page-container">
                    <div className="category-head">
                        <h3 className="channel-title">
                            <FormattedMessage id="vod"
                                defaultMessage="Video on Demand"
                            />
                        </h3>
                    </div>
                    <ul className="list-unstyled video-list video-list--history">
                        {bidiotvsearch?
                            bidiotvsearch.map((video) => {
                                return (
                                    <li key={video.id} className="video-list__item video-list__item--history" onClick={this.goToPlay.bind(this, {video: video, id: video.id})}>
                                        <div className="video-list__image video-list__image--history">
                                            <div className="channels-image">
                                                <div className="channels-image channels-image--genre channels-image--list no-radius">
                                                    <img className="channels-thumb__image no-radius"  src={video.preview} alt={video.name} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="video-list__details video-list__details--history">
                                            <div className="video-list__upper">
                                                <div className="video-list__upper__left">
                                                    <h4 className="channels-thumb__name channels-thumb__name--list my-0">{video.name}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                )
                            })
                            : ""
                        }
                    </ul>
                </div>
            )

        }
        else  if(config.title == 'es' && window.innerWidth <= 575){
            const portraitSlides = {
                spaceBetween: 10,
                direction: 'horizontal',
                slidesPerView: 'auto',
                speed: 500,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            };
            return(
                esmobiotv.map((category) => {
                    let newVideos = category.videos.filter((video) => {
                        if (regEx.test(video.name)) {
                            return video;
                        }
                    });
                    if (newVideos.length > 0) {
                        return (
                            <div className="search-page--es">
                                <div key={category.id} className="portrait-wrapper">
                                    <div className="d-flex justify-content-between channel-head">
                                        <h3 className="channel-title">{category.name}</h3>
                                    </div>
                                    {newVideos.length > 0 ?
                                        <Swiper {...portraitSlides} rebuildOnUpdate={false}
                                                shouldSwiperUpdate={true}>
                                            {newVideos.reverse().map((m) => {
                                                return (
                                                    <div key={m.id} className="portrait__slide hover__data"
                                                            onClick={this.goToPlayOthers.bind(this, {show: m, id: m.id})}>
                                                        <img src={m.preview} alt={m.name}/>
                                                        <div className="hover__details">
                                                            <div className="hover__container">
                                                                <div className="hover__title-wrap">
                                                                    <h3 className="hover__title">{m.name}</h3>
                                                                </div>
                                                                <span className="hollow-arrow"
                                                                        dangerouslySetInnerHTML={{__html: playIcon}}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            }
                                        </Swiper>
                                        : ''
                                    }
                                </div>
                            </div>
                        )
                    }
                })
            )
        }
        else if(config.title == 'es' && window.innerWidth >= 576){
            return(
                <div className="search-page-container">
                    <div className="category-head">
                        <h3 className="channel-title">Vídeo a la carta</h3>
                    </div>
                    <ul className="list-unstyled video-list video-list--history">
                        {videoSearch?
                            videoSearch.map((m) => {
                                return (
                                    <li key={m.id} className="shows hover__data" onClick={this.goToPlayOthers.bind(this, {show: m, id: m.id})}>
                                        <img className="shows__thumb" src={m.preview} alt={m.name} />
                                        <div className="hover__details">
                                            <div className="hover__container">
                                                <div className="hover__title-wrap">
                                                    <h3 className="hover__title">{m.name}</h3>
                                                </div>
                                                <span className="hollow-arrow" dangerouslySetInnerHTML={{ __html: playIcon }} />
                                            </div>
                                        </div>
                                    </li>
                                )
                            })
                            : ""
                        }
                    </ul>
                </div>
            )
        }
        else if(this.state.type == "channels" && channelSearch.length > 0){
            return(
                <div className="search-page-container">
                    <div className="category-head">
                        <h3 className="channel-title">
                            <FormattedMessage id="liveChannels"
                                defaultMessage="Live Channels"
                            />
                        </h3>
                    </div>
                    <ul className="list-unstyled video-list video-list--history">
                        {channelSearch?
                            channelSearch.map((channel) => {
                                return (
                                    <li key={channel.channelId} className="video-list__item video-list__item--history" onClick={this.goToPlay.bind(this, {channel: channel, id: channel.channelId})}>
                                        <div className="video-list__image video-list__image--history">
                                            <div className="channels-image">
                                                <div className="channels-image channels-image--genre channels-image--list no-radius">
                                                    <img className="channels-thumb__image no-radius" src={channel.channelImage ? vars.BASE_URL+"uploads/"+channel.channelImage : "./img/thumbnail-2.jpg"} alt={channel.channelName} />
                                                    <img className="channels-thumb__icon channel-thumb__icon--list" src={channel.channelLogo} alt={channel.channelName} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="video-list__details video-list__details--history">
                                            <div className="video-list__upper">
                                                <div className="video-list__upper__left">
                                                    <h4 className="channels-thumb__name channels-thumb__name--list my-0">{channel.channelName}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                )
                            })
                            : ""
                        }
                    </ul>
                </div>
            )

        }
        else if((this.state.type == "videos") && (videoSearch.length > 0 || recentSearch.length > 0)){
            return(
                <div className="search-page-container">
                    <div className="category-head">
                        <h3 className="channel-title">
                            <FormattedMessage id="vod"
                                defaultMessage="Video on Demand"
                            />
                        </h3>
                    </div>
                    <ul className="list-unstyled video-list video-list--history">
                        {videoSearch?
                            videoSearch.map((video) => {
                                return (
                                    <li key={video.id} className="video-list__item video-list__item--history" onClick={this.goToPlay.bind(this, {video: video, id: video.id})}>
                                        <div className="video-list__image video-list__image--history">
                                            <div className="channels-image">
                                                <div className="channels-image channels-image--genre channels-image--list no-radius">
                                                    <img className="channels-thumb__image no-radius" src={video.preview} alt={video.name} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="video-list__details video-list__details--history">
                                            <div className="video-list__upper">
                                                <div className="video-list__upper__left">
                                                    <h4 className="channels-thumb__name channels-thumb__name--list my-0">{video.name}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                )
                            })
                            : ""
                       }
                    </ul>
                    <ul className="shows__wrap">
                    {recentSearch?
                            recentSearch.map((m) => {
                                return (
                                    <li key={m.id} className="shows hover__data" onClick={this.goToPlayOthers.bind(this, {show: m, id: m.id})}>
                                        <img className="shows__thumb" src={m.preview} alt={m.name} />
                                        <div className="hover__details">
                                            <div className="hover__container">
                                                <div className="hover__title-wrap">
                                                    <h3 className="hover__title">{m.name}</h3>
                                                </div>
                                                <span className="hollow-arrow" dangerouslySetInnerHTML={{ __html: playIcon }} />
                                            </div>
                                        </div>
                                    </li>
                                )
                            })
                            : ""
                    }
                    </ul>
                </div>
            )

        }
        else if(channelSearch.length <= 0 && videoSearch.length <=0 && recentSearch.length <= 0){
            return(
                <div className="no-favorites__pane no-favorites__pane--history">
                    <h4 className="favorites__pane__title">
                        <FormattedMessage id="noResults"
                            defaultMessage="No Results Found"
                        />
                    </h4>
                </div>
            )

        }
      else {
            return(
                <div></div>
            )
        }

    }

	render() {
	    return (
			<section className="search-page">
                {this.searchvideos()}
			</section>
		)
	}
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        header: state.HeaderReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        search: state.SearchReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        searchText,
        getVideoOrChannelRelatedData,
        showSearchBar
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);



// WEBPACK FOOTER //
// ./src/components/SearchPage/SearchPage.js